<template>
  <div
      :id="pickerId"
      :class="['color-pickr', popupStyle ? 'popup-style border-radius' : '']"
      :style="{
        top: `${yPosition}px`,
        left: `${xPosition}px`,
        position: positioning
      }"
  >
    <color-picker
        ref="cp"
        :color="color"
        :sucker-area="suckerArea"
        :sucker-canvas="suckerCanvas"
        :sucker-hide="true"
        :colors-default="['#ffffff', '#000', '#FFB3BA', '#FFDFBA', '#FFFFBA', '#BAFFC9', '#BAE1FF', '#D5BAFF']"
        theme="dark"
        @changeColor="changeColor"
    />
    <div v-if="showSaveButton" class="settings-button action-button d-inline-block mt-2 ml-1" @click="save">
      <icon type="save"/>
      {{ $t("SAVE") }}
    </div>
    <div class="settings-button switched-colors d-inline-block mt-2" @click="close">
      <icon type="times"/>
      {{ $t("abort") }}
    </div>
  </div>
</template>

<script>
//https://www.npmjs.com/package/@caohenghu/vue-colorpicker
import colorPicker from "@caohenghu/vue-colorpicker";
import Icon from "../../Icon";
import listenerMixinJs from "../../mixins/listenerMixin.js.vue";

export default {
  name: "ColorPicker",
  components: {
    colorPicker,
    Icon,
  },
  mixins: [listenerMixinJs],
  props: {
    popupStyle: {type: Boolean, default: false},
    value: {type: String, default: null},
    showSaveButton: {type: Boolean, default: true},
    hasTransparency: {type: Boolean, default: true},
    event: {type: PointerEvent, default: null},
  },
  data() {
    return {
      color: "#000",
      suckerCanvas: null,
      suckerArea: [],
      isSucking: false,
      originalTop: 0,
      originalLeft: 0,
      xPosition: 0,
      yPosition: 0,
      positioning: 'fixed',
      pickerId: null,
      viewportWidth: 0,
      viewportHeight: 0,
    };
  },
  watch: {
    event(val) {
      if (val) {
        this.positionColorPicker();
      }
    },
  },
  beforeMount() {
    this.pickerId = Date.now() + Math.floor(Math.random() * 1000);
    if (this.value && this.value.startsWith("#")) {
      //this.color = this.value;
      this.color = this.hexToRgbA(this.value);
    } else if(this.value) {
      this.color = this.value;
    }
    const $this = this;
    this.addListener(window, 'resize', function () {
      $this.moveColorPickerIntoViewport();
    }, this.id);
  },
  mounted() {
    this.positionColorPicker();
  },
  methods: {
    moveColorPickerIntoViewport() {
      this.$nextTick(() => {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const xDiff = this.viewportWidth - viewportWidth;
        const yDiff = this.viewportHeight - viewportHeight;

        const component = document.getElementById(this.pickerId);
        let {left, top} = component.getBoundingClientRect();

        left = left - xDiff;
        top = top - yDiff;

        this.xPosition = left;
        this.yPosition = top;
        this.viewportWidth = viewportWidth;
        this.viewportHeight = viewportHeight;
      });
    },
    positionColorPicker() {
      if(!this.event) {
        return;
      }
      let {clientX: left, clientY: top} = this.event;
      this.$nextTick(() => {
        this.viewportWidth = window.innerWidth;
        this.viewportHeight = window.innerHeight;

        const component = document.getElementById(this.pickerId);
        const {width: componentWidth, height: componentHeight} = component.getBoundingClientRect();

        // If the component goes beyond the right edge of the viewport
        if ((left + componentWidth) > this.viewportWidth) {
          left = this.viewportWidth - componentWidth - 10; // 10px padding
        }

        // If the component goes beyond the bottom edge of the viewport
        if ((top + componentHeight) > this.viewportHeight) {
          top = this.viewportHeight - componentHeight - 10; // 10px padding
        }

        this.xPosition = left;
        this.yPosition = top;
      });
    },
    deliverColor() {
      if (this.color.startsWith("#")) {
        return this.color;
      } else if (!this.hasTransparency) {
        return "#" + this.rgba2hex(this.color, false);
      } else {
        return "#" + this.rgba2hex(this.color);
      }
    },
    changeColor(color) {
      const {r, g, b, a} = color.rgba;
      this.color = `rgba(${r}, ${g}, ${b}, ${a})`;
      this.$emit('changeColor', this.deliverColor());
    },
    hexToRgbA(hex) {
      hex = hex.substring(1);
      if (hex.length === 3) {

        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      // Split to four channels
      let c = hex.match(/.{1,2}/g);
      // Function: to decimals (for RGB)
      const d = function (v) {
        return parseInt(v, 16);
      };

      // Function: to percentage (for alpha), to 3 decimals
      //2 decimals .. 3 is not correct.. cannot map consistent bewteen alpha and hex with 3 decimals
      const p = function (v) {
        return parseFloat(parseInt((parseInt(v, 16) / 255) * 1000) / 1000).toFixed(2);
      };

      // Check format: if it's argb, pop the alpha value from the end and move it to front
      let a,
          rgb = [];
      /*if($('#format').val() === 'argb') {
          c.push(c.shift());
        }*/

      // Convert array into rgba values
      a = c[3] ? p(c[3]) : 1;
      const arr = c.slice(0, 3);
      arr.map((item) => {
        rgb.push(d(item));
      });

      return "rgb(" + rgb.join(",") + "," + a + ")";
    },
    rgba2hex(orig, includeTransparency = true) {
      var a,
          rgb = orig
              .replace(/\s/g, "")
              .match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
          alpha = ((rgb && rgb[4]) || "").trim(),
          hex = rgb
              ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
              (rgb[2] | (1 << 8)).toString(16).slice(1) +
              (rgb[3] | (1 << 8)).toString(16).slice(1)
              : orig;

      if (alpha !== "") {
        a = alpha;
      } else {
        a = 1;
      }
      if (!includeTransparency) {
        return hex;
      }
      // multiply before convert to HEX
      a = ((a * 255) | (1 << 8)).toString(16).slice(1);
      hex = hex + a;
      return hex;
    },
    /*openSucker(isOpen) {
            if (isOpen) {
                // ... canvas be created
                // this.suckerCanvas = canvas
                // this.suckerArea = [x1, y1, x2, y2]
            } else {
                // this.suckerCanvas && this.suckerCanvas.remove
            }
        },*/
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit('save', this.deliverColor());
    },
  },
};
</script>

<style lang="scss" scoped>
.color-pickr.popup-style {
  position: fixed;
  background-color: var(--vform-editor-ui-secondary-color);
  border: 1px solid rgba(255,255,255,0.1);
  padding: 8px;
  z-index: 1530;
  top: 0;
  left: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);

  .hu-color-picker {
    background-color: var(--vform-editor-ui-secondary-color);
    box-shadow: none;
    min-width: 218px;
    margin: auto;
  }

  .popup-close {
    position: absolute;
    top: 15px;
    right: 17px;
    z-index: 4;
  }
}

.close-color-picker {
  color: #fff;
  transition: all 300ms ease;
  &:hover {
    color: rgba(255,255,255,0.4);
  }
}

.hu-color-picker {
  //also apply the min-width when not in pop-up style, as it affects color pickers used in metafield editor
  min-width: 218px;
}
</style>